import React from 'react';
import styles from './TextInput.module.scss';
import { Text } from '../../Typography/Typography';

export interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  error?: string;
  labelColor?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  fullWidth = false,
  error,
  className,
  id,
  labelColor = 'neutral-600',
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const inputClasses = [
    styles.input,
    error ? styles.error : '',
    fullWidth ? styles.fullWidth : '',
    className || '',
  ].join(' ');

  const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className={`${styles.inputContainer} ${fullWidth ? styles.fullWidth : ''}`}>
      {label && (
        <label htmlFor={inputId} className={styles.labelWrapper}>
          <Text size="small" weight="medium" color={labelColor}>
            {label}
          </Text>
        </label>
      )}
      <input
        id={inputId}
        className={inputClasses}
        value={value}
        onChange={handleChange}
        {...props}
      />
      {error && (
        <Text size="small" color="#FF6A55" className={styles.errorMessage}>
          {error}
        </Text>
      )}
    </div>
  );
};

export default TextInput;
